import { CandidateApplicationStatus } from "@/types";

const statusLabelMap: Record<CandidateApplicationStatus, string> = {
  Identified: "Identified",
  "Initial Outreach": "Initial Outreach",
  "Not Interested": "Opted-Out",
  "Checking Interest": "Opt-In Requested",
  Screening: "Opted-In",
  "Possible Fit": "Possible Fit",
  Shortlisted: "Shortlisted",
  "Making Offer": "Making Offer",
  Contracting: "Contracting",
  "Accepted by Client": "Accepted by Client",
  "Rejected for Role": "Rejected for Role",
};

const jobCandidateStatusToLabel = (status?: CandidateApplicationStatus) =>
  statusLabelMap[status ?? "Rejected for Role"];

export default jobCandidateStatusToLabel;
